import { isUnknownObject } from '~/shared/utils/guards'
import { BaseModel, fillOwnProperties } from '~/shared/model'
import { toCroppedImage } from '~/shared/utils/image'

export default class TextTask extends BaseModel {
  static override constructorName = 'TextTask'

  public color: string = ''
  public icon: string = ''
  public text: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.icon = toCroppedImage(data.icon)
    }
  }
}
